import { render, staticRenderFns } from "./MainError.vue?vue&type=template&id=784c24b1&scoped=true"
import script from "./MainError.vue?vue&type=script&lang=js"
export * from "./MainError.vue?vue&type=script&lang=js"
import style0 from "./MainError.vue?vue&type=style&index=0&id=784c24b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c24b1",
  null
  
)

export default component.exports